module.exports = __webpack_public_path__ + "media/proksee-viewer/images/search-begins-with-5da6e21ccc474350d134831cd8ee257d.png";